import { getTypographyStyles } from '@oneaudi/unified-web-common';
import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import {} from './index.js';
import { getMargins, SYS_SIZE_FIXED_500, SYS_SIZE_FIXED_300, SYS_SIZE_FIXED_200, SYS_SIZE_FIXED_400, SYS_SPACE_FIXED_100, SEM_TYPOGRAPHY_FORMS_LABEL, SEM_BORDER_WIDTH_FORMS_DEFAULT, SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-common';
// TODO: add readOnly style
const marginLeft = parseFloat(SYS_SIZE_FIXED_500) + parseFloat(SYS_SPACE_FIXED_150);
export const StyledFormMessage = styled(FormMessage) `
  margin-left: ${marginLeft}px;
`;
export const StyledRadioContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const StyledTextContent = styled.div `
  display: flex;
  align-items: baseline;
  gap: ${SYS_SPACE_FIXED_150};
  transition-property: color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
export const StyledRadioIndicator = styled.div `
  width: ${SYS_SIZE_FIXED_500};
  box-sizing: border-box;
  height: ${SYS_SIZE_FIXED_500};
  border: ${SEM_BORDER_WIDTH_FORMS_DEFAULT} solid
    ${(props) => props.theme.sem.color.forms.surface.control.stroke.default};
  flex-shrink: 0;
  transition-property: border-color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    width: ${SYS_SIZE_FIXED_300};
    height: ${SYS_SIZE_FIXED_300};
    background-color: ${(props) => props.theme.sem.color.forms.surface.control.indicator.default};
    border-radius: 50%;
    transform: scale(0);
    transform-origin: 50%;
    content: '';
    visibility: hidden;
    transition-property: transform, visibility, height, width;
    // TODO: token missing;
    transition-duration: 0.1s;
    // TODO: token missing;
    transition-timing-function: ease;
    ${(props) => props.invalid &&
    css `
        background-color: ${props.theme.sem.color.forms.surface.control
        .indicator.error};
      `}
  }
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;

  &:hover:not(:disabled) + ${StyledRadioIndicator}::before {
    width: ${SYS_SIZE_FIXED_200};
    height: ${SYS_SIZE_FIXED_200};
  }

  &:checked:active:not(:disabled) + ${StyledRadioIndicator}::before {
    width: ${SYS_SIZE_FIXED_400};
    height: ${SYS_SIZE_FIXED_400};
  }

  &:checked + ${StyledRadioIndicator}::before {
    transform: scale(1);
    visibility: visible;
  }

  &:focus {
    & + ${StyledRadioIndicator} {
      outline: 2px solid Highlight;
      outline: 2px solid -webkit-focus-ring-color;
      outline-style: auto;
    }
  }

  &:focus:not(:focus-visible) + ${StyledRadioIndicator} {
    outline: none;
  }

  ${(props) => !props.invalid &&
    css `
      &:hover:not(:disabled) + ${StyledRadioIndicator} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.stroke.interactive};
      }
      &:checked:active:not(:disabled) + ${StyledRadioIndicator} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.stroke.interactive};
      }
    `}

  ${(props) => !props.$readOnly &&
    css `
      &:disabled + ${StyledRadioIndicator} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.stroke.disabled};
      }

      &:disabled + ${StyledRadioIndicator}::before {
        background-color: ${(props) => props.theme.sem.color.forms.surface.control.indicator.disabled};
      }
    `}

  ${(props) => props.$readOnly &&
    css `
      &:disabled + ${StyledRadioIndicator} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.stroke.readOnly};
        background-color: ${(props) => props.theme.sem.color.forms.surface.control.fill.readOnly};
      }

      &:disabled + ${StyledRadioIndicator}::before {
        background-color: ${(props) => props.theme.sem.color.forms.surface.control.indicator.readOnly};
      }
    `}
`;
export const StyledLabel = styled.label `
  cursor: ${(props) => (props.$readOnly ? 'initial' : 'pointer')};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)};
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  display: flex;
  column-gap: ${SYS_SPACE_FIXED_150};
  align-items: flex-start;
  ${(props) => !props.invalid &&
    css `
      &:has(${StyledInput}:disabled) {
        cursor: not-allowed;
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
        }
      }
      &:has(${StyledInput}:hover:not(:disabled)) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
        }
      }
      &:has(${StyledInput}:checked:not(:disabled)) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
        }
      }
    `}

  ${(props) => props.invalid &&
    css `
      ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.stroke
        .error};
      }
      ${StyledTextContent} {
        color: ${props.theme.sem.color.forms.foreground.text.error};
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map